var exports = {
  "i": "xa15a2ab7--572465--wrapper",
};

module.exports = exports;
